import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=dabf5b7e&scoped=true&"
var script = {}
import style0 from "./Help.vue?vue&type=style&index=0&id=dabf5b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabf5b7e",
  null
  
)

export default component.exports